import React from 'react';
import Container from '@mui/material/Container';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { About } from './pages/About';
import { Home } from './pages/Home';
import { Store } from './pages/Store';
import { FeedFromSlug } from './pages/FeedFromSlug';
import { SinglePostFromId } from './pages/SinglePostFromId';
import { DemoLinks } from './pages/DemoLinks';
import { Navbar } from './components/Navbar';

import { createTheme, ThemeProvider } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#BC9D58',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth={false}
        disableGutters={true}
        sx={{ justifyContent: 'flex-start' }}
      >
        <Routes>
          {/* <Route path='/' element={<Home />} /> */}
          {/* <Route path='/' element={<SinglePostFromId />} /> */}
          <Route path='/' element={<FeedFromSlug />} />
          <Route path='/C--membertomembernetwork' element={<Store />} />
          <Route path='/C--philanthropy' element={<About />} />
          <Route path='/feed-from-slug' element={<FeedFromSlug />} />
          <Route
            path='/single-post-from-id/:id'
            element={<SinglePostFromId />}
          />
        </Routes>
      </Container>
    </ThemeProvider>
  );
  return <h1>Hello Sumeet</h1>;
}

export default App;
